"use client";

import SList from "@public/image/icon/list.svg";
import SLogo from "@public/image/icon/logo.svg";
import SX from "@public/image/icon/x.svg";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useEffect, useRef, useState } from "react";
import { HEADER_LINKS } from "@/constants/header";
import { PATH } from "@/constants/path";
import { trackEvent } from "@/utils/analytics";
import Button from "../Button";
import HeaderItem from "./atoms/HeaderItem";

function HeaderMobile() {
  const [isOpen, setOpen] = useState<boolean>(false);
  const impressionFiredRef = useRef(false);

  const path = usePathname();

  const toggleNavBar = () => {
    setOpen((prev) => !prev);
  };

  const closeNavBar = () => {
    setOpen(false);
  };

  const handleGnbClick = (menuItem: string) => {
    trackEvent("gnb_click", path, {
      menu_item: menuItem,
      page_location: window.location.pathname,
    });
    closeNavBar();
  };

  const handleCtaClick = (ctaType: string) => {
    trackEvent("cta_click", path, {
      cta_type: ctaType,
      cta_position: "gnb",
    });
    closeNavBar();
  };

  // 모바일 메뉴 열릴 때 impression 이벤트 발송 (1회)
  useEffect(() => {
    if (isOpen && !impressionFiredRef.current) {
      impressionFiredRef.current = true;
      const items = [
        { eventName: "gnb_impression", params: { menu_item: "logo", page_location: "/" } },
        ...HEADER_LINKS.map((l) => ({
          eventName: "gnb_impression",
          params: { menu_item: l.label.toLowerCase(), page_location: "/" },
        })),
        { eventName: "gnb_impression", params: { menu_item: "jd_creator", page_location: "/" } },
        { eventName: "cta_impression", params: { cta_type: "inquiry", cta_position: "gnb" } },
      ];
      for (const item of items) {
        trackEvent(item.eventName, path, { ...item.params, viewport_percent: 50 });
      }
    }
  }, [isOpen]);

  return (
    <div
      className="fixed left-0 top-0 z-50 flex h-16 w-screen flex-col items-center justify-center bg-white px-4 header:hidden">
      <div className="flex w-full items-center justify-between">
        {/* 로고 */}
        <Link href="/" onClick={() => handleGnbClick("logo")}>
          <SLogo className="w-32" />
        </Link>

        <button onClick={toggleNavBar}>{isOpen ? <SX className="size-8" /> : <SList className="size-8" />}</button>
      </div>

      {isOpen && (
        <div
          className="absolute left-0 top-16 z-50 flex w-full flex-col items-center gap-4 bg-white pb-7 backdrop-blur-sm">
          {/* 링크 목록 */}
          <div className={`flex w-full flex-col items-center gap-1`}>
            {HEADER_LINKS.map(({ label, href }) => (
              <HeaderItem key={href} href={href} className="w-full" onClick={() => handleGnbClick(label.toLowerCase())}>
                {label}
              </HeaderItem>
            ))}
          </div>
          {/* 버튼 목록 */}
          <div className="flex gap-2">
            <a
              href="https://jd-creator.searchright.net?utm_source=homepage&utm_medium=organic&utm_campaign=header-button&utm_content=jd"
              target="_blank"
              rel="noopener noreferrer"
              className="relative rounded-md border border-primary bg-blue-50 px-4 py-2 text-14 font-normal text-primary"
              onClick={() => handleGnbClick("jd_creator")}
            >
              JD Creator
              <span
                className="absolute -right-2 -top-2 rounded bg-primary px-1.5 py-0.5 text-[10px] font-bold leading-none text-white">
                BETA
              </span>
            </a>
            <Button color="primary" size="sm" href={PATH.REQUEST} onClick={() => handleCtaClick("inquiry")}>
              문의하기
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}

export default HeaderMobile;
